import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { updateHeaderInfo } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import Form from 'apps/auth/components/form-multi/Form';
import { WAITLIST_NOTIFY_ME_CLICKED, WAITLIST_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useApp, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const WaitingListDisclaimer = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { waitingListBtnContinue, waitingListHeaderText, waitingListHeaderInfo, headerInfo } = usePageMessages();
    const submitRef = useRef(null);

    useEffect(() => {
        props.updateHeaderInfo('');
        props.sendEvent(WAITLIST_SCREEN_SHOWN);
        return () => {
            props.updateHeaderInfo(headerInfo);
        };
    }, []);

    const disclaimerAgreeClick = (e) => {
        if (props.disclaimerAgreeClick) {
            props.disclaimerAgreeClick();
            e.preventDefault();
        }
    };

    return (
        <BaseLayout>
            <Form
                formName={props.formName}
                onSubmitHandler={props.onSubmitHandler}
                getCanonicalPath={props.getCanonicalPath}
                action={props.action}
                checkNotVisibleField={false}
            >
                <InfoPage
                    diskButtonOnClick={props.onBackIconClick}
                    iconName="rocket-80"
                    iconColor="primary"
                    headerText={waitingListHeaderInfo}
                    secondaryText={waitingListHeaderText}
                    primaryButtonType="button"
                    primaryButtonCaption={waitingListBtnContinue}
                    primaryButtonOnClick={(e) => {
                        props.sendEvent(WAITLIST_NOTIFY_ME_CLICKED);
                        disclaimerAgreeClick(e);
                    }}
                    backUrl={`${getLangCountryPrefix(lang, country)}`}
                    isTagA
                    primaryButtonDataTestId="waiting-list-disclaimer-agree-button"
                />
                <Button type="submit" variant={'hidden'} ref={submitRef} />
            </Form>
        </BaseLayout>
    );
};

export default connect(null, { updateHeaderInfo })(WaitingListDisclaimer);
